<template>
  <div class="pageContainer app-container">
    <el-row class="flexStart">



      <el-select v-if="$store.state.pmid == 20" v-model="searchForm.ctype" size="small" placeholder="请选择"
        style="width: 200px; margin-right: 10px" @change="getList">
        <el-option label="全部学生" value="">全部学生</el-option>
        <el-option label="招办学生" :value="1">招办学生</el-option>
        <el-option label="自报名学生" :value="0">自报名学生</el-option>

      </el-select>

      <el-select  v-model="searchForm.sp_status" size="small" placeholder="请选择"
        style="width: 200px; margin-right: 10px" @change="getList">
        <el-option label="全部学生" value="">全部学生</el-option>
        <el-option label="待审批" :value="0">待审批</el-option>
        <el-option label="审批通过" :value="1">审批通过</el-option>
        <el-option label="审批拒绝" :value="-1">审批拒绝</el-option>

      </el-select>
      
    </el-row>

    <el-table :data="DataList" stripe border style="margin-top:10px">
      <el-table-column type="index" label="编号" width="80">
      </el-table-column>
      <el-table-column prop="stu_name" label="姓名" width="120">
      </el-table-column>
      <el-table-column prop="exam_num" label="准考证号" width="150">
      </el-table-column>
      <el-table-column prop="identity_card" label="身份证号" width="200">
      </el-table-column>
      <el-table-column prop="title" label="专业" width="150">
      </el-table-column>
      <el-table-column prop="item_desc" label="学制" width="100">
      </el-table-column>
      
     <el-table-column prop="flag" label="自主报名" width="90">
				<template slot-scope="scope">
					<span v-if="scope.row.ctype == 0" style="color: green;">是</span>
					<span v-else style="color: blue;">否</span>
				</template>
			</el-table-column>
      <el-table-column prop="reason" label="退档原因" min-width="100">
      </el-table-column>
      <el-table-column prop="sp_status" label="审批状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.sp_status === ''">未申请</span>
          <span v-else-if="scope.row.sp_status === 0" style="color:blue">已提交待审批</span>
          <span v-else-if="scope.row.sp_status === 1" style="color:lightgreen">审批通过</span>
          <span v-else-if="scope.row.sp_status === -1" style="color:brown">审批拒绝</span>

        </template>
      </el-table-column>

      <el-table-column prop="sp_word" label="审批结果" width="150">

      </el-table-column>

      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">

          <el-button v-if="scope.row.sp_status === 0" type="text" @click="update(scope.row)">审批</el-button>

        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="退档审批" :visible.sync="dialogVisible" :close-on-click-modal="false">


      <el-form :model="EditItem" ref="EditItem" label-width="120px">

        <el-row style="padding-top: 20px;">
          <el-col :span="20">
            <el-form-item label="是否通过">
              <el-select v-model="EditItem.sp_status">
                <el-option label="未审批" :value="0">未审批</el-option>
                <el-option label="审批通过" :value="1">审批通过</el-option>
                <el-option label="审批拒绝" :value="-1">审批拒绝</el-option>
              </el-select>

            </el-form-item>

          </el-col>
        </el-row>
        <el-row style="padding-top: 0px;">
          <el-col :span="22">
            <el-form-item label="审批结果说明">
              <el-input v-model="EditItem.sp_word"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <el-row>
        <el-col :span="22" style="text-align: right;">
          <el-button type="primary" @click="saveForm">确定审批</el-button>
        </el-col>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      searchForm: { ctype: "" , sp_status: "",},
      EditItem: {

        id: 0,
       
        sp_word: ""
      },
      DataList: [],

    }
  },
  mounted() {
    this.getList();
    console.log(this.EditItem)
  },
  methods: {
    getList() {
      this.$http.post("/api/stu_self_tuidang_list", {
        ctype:this.searchForm.ctype,
        sp_status:this.searchForm.sp_status,
      }).then(res => {
        this.DataList = res.data
      })
    },
    update(item) {
      this.dialogVisible = true

      this.EditItem = item;
    },

    remove(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post("/api/mini_banner_delete", {
          id: id
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          });

          this.getList();
        })

      }).catch(() => {

      });
    },
    saveForm() {
      if (this.EditItem.tdid > 0) {
        this.$http.post("/api/stu_self_tuidang_sp", {
          id: this.EditItem.tdid,
          sp_status: this.EditItem.sp_status,
          sp_word: this.EditItem.sp_word,
        }).then(res => {
          this.$message({
            type: 'success',
            message: '审批成功'
          });
          this.dialogVisible = false
          this.getList();
        })
      } else {


      }
    }
  }
}
</script>

<style scoped>
</style>
